export default Object.freeze({
    //account/LoginService  starts
    //SIGN_IN: '/account/mta/login',
    NEW_SIGNIN: "/Account/login",
    NEW_RESETPASSWORD: "/Account/forgotpassword",
    SEND_RESET_EMAIL: "/account/sendresetemail",
    CHANGE_PASSWORD: "/Account/changepassword",
    SIGN_OUT: "/account/mta/logout",
    //account/LoginService  ends

    //account/ResetService  starts
    RESET_TOKEN: "/account/resetpasswordviatoken",

    //configuration/RoleService  starts
    ROLE_LIST: "/Role/list",
    ROLE_ADD: "/Role/add",
    TASK_ACTION: "/Role/taskactionlist",
    ROLE_BY_ID: "/Role/get?id=${id}",
    ROLE_UPDATE: "/Role/update",
    //configuration/RoleService  ends

    //views/usermanagement/manageAcess  starts
    MTA_ROLE: "/Role/mta/roleaction",
    INIT_ROLE: "/Roles/init",
    CREATE_ROLE: "/Roles",
    UPDATE_ROLE: "/Roles",
    ROLES_GRID: "/Roles/list",
    APPROVE_PENDING: "/Role/mta/approvepending",
    REJECT_PENDING: "/Role/mta/rejectpending",
    APPROVAL: "/Role/mta/approvalpending/",
    APPROVAL_LIST: "/Role/mta/list/approvalpending",
    //views/usermanagement/manageAcess  ends

    //views/usermanagement/managerole  starts
    LIST_ROLE: "/Roles/List",
    DELETE_ROLE: "/Roles",

    //views/usermanagement/managerole  ends

    //views/usermanagement/manageUser  starts
    USER_INIT: "/Users/init/",
    USER_UPDATE: "/Users",
    USER_DELETE: "/Users",
    USER_LIST: "/Users/list",
    GET_USER: "/Users/list",
    ADD_USER: "/Users",
    USER_UNLOCK: "/Users/unlockuser",
    USER_LOCK: "Users/blockuser",
    //views/usermanagement/manageUser  ends

    //otp
    OTP_LIST: "/Otp/list",
    OTP_REQUEST: "/Otp/request",
    OTP_VALIDATE: "/Otp/validate",

    //otpverify
    OTP_VERIFY: "/Account/resetpassword/otpverify",
    //resetpassword
    RESET_PASSWORD: "/Account/resetpassword",

    //systemManagement-currency
    CURRENCY_LIST: "/SystemManagement/currency/list",
    CURRENCY_INIT: "/SystemManagement/currency/init",
    CURRENCY_ADD: "/SystemManagement/currency",
    CURRENCY_UPDATE: "/SystemManagement/currency",
    CURRENCY_GETBYID: "/SystemManagement/currency/init/",

    SERVICE_LIST: "/SystemManagement/servicefee/list",
    SERVICE_INIT: "/SystemManagement/servicefee/init",
    SERVICE_ADD: "/SystemManagement/servicefee",
    SERVICE_UPDATE: "/SystemManagement/servicefee",
    SERVICE_GETBYID: "/SystemManagement/servicefee/init/",

    //systemManagement-rate
    RATE_LIST: "/SystemManagement/rate/approval/list",
    RATE_INIT: "/SystemManagement/rate/init",
    RATE_GETBYID: "/SystemManagement/rate/get",
    RATE_ADD: "/SystemManagement/rate",
    RATE_APPROVE: "/SystemManagement/rate/approve",

    APPROVED_RATE_LIST: "/SystemManagement/rate/approved/list",

    //systemManagement-country
    COUNTRY_LIST: "/SystemManagement/country/list",
    COUNTRY_CHANGESTATUS: "/SystemManagement/country/changestatus",

    //systemManagement-country-organization
    COUNTRY_ORGANIZATION_LIST: "/SystemManagement/country/organization/list",
    COUNTRY_ORGANIZATION_CHANGESTATUS:
        "SystemManagement/country/organization/changestatus",

    //systemManagement-prefund
    PREFUND_LIST: "/SystemManagement/prefund/list",
    PREFUND_INIT: "/SystemManagement/prefund/init",
    PREFUND_CALCULATE_RATE: "/SystemManagement/prefund/calculate/rate",
    CREATE_PREFUND: "/SystemManagement/prefund",
    PREFUND_INQUIRY_BALANCE: "/SystemManagement/prefund/inquiry/balance",
    //banner
    ADD_BANNER: "/Banner/add",
    UPDATE_BANNER: "/Banner/update",
    BANNER_LIST: "/Banner/list",
    BANNER_GETBYID: "/Banner/get",
    BANNER_DELETE: "/Banner/delete",

    //Faq
    ADD_FAQ: "/Faq/add",
    UPDATE_FAQ: "/Faq/update",
    FAQ_LIST: "/Faq/list",
    FAQ_GETBYID: "/Faq/get",
    FAQ_DELETE: "/Faq/delete",

    //customerManagement
    CUSTOMER_MANAGEMENT_LIST: "/customer/list",
    CUSTOMER_MANAGEMENT_UPDATE: "/customer/update",
    CUSTOMER_MANAGEMENT_ADD: "/customer/add",
    CUSTOMER_MANAGEMENT_GETBYID: "/customer/get",

    CUSTOMER_MANAGEMENT_STATUS: "/customer/status/#id/#status",

    //imageupload
    IMAGE_UPLOAD: "/upload",

    //processcontent
    ADD_PROCESS_CONTENT: "/process-content",
    UPDATE_PROCESS_CONTENT: "/process-content/update",
    PROCESS_CONTENT_LIST: "/process-content/list",
    PROCESS_CONTENT_GETBYID: "/process-content/",
    PROCESS_CONTENT_DELETE: "/process-content",

    //Testimonials
    ADD_TESTIMONIAL: "/testimonial",
    UPDATE_TESTIMONIAL: "/testimonial",
    LIST_TESTIMONIAL: "/testimonial/list",
    GET_BYID_TESTIMONIAL: "/testimonial",
    DELETE_TESTIMONIAL: "/testimonial",

    //advertisement
    ADD_ADVERTISEMENT: "/advertisement/add",
    UPDATE_ADVERTISEMENT: "/advertisement/update",
    LIST_ADVERTISEMENT: "/advertisement/list",
    GET_BYID_ADVERTISEMENT: "/advertisement/get",
    DELETE_ADVERTISEMENT: "/advertisement/delete",

    //content
    ADD_CONTENT: "/content/add",
    UPDATE_CONTENT: "/content/update",
    CONTENT_LIST: "/content/list",
    GET_BYID_CONTENT: "/content/get",
    DELETE_CONTENT: "/content/delete",
    GET_PAGE_SLUG: "/content/page/",
    GET_PAGE: "/content/page",
    CONTENT_CONTACT_US: "/content/contact-us",

    //Service
    ADD_SERVICE: "/Service",
    UPDATE_SERVICE: "/Service",
    LIST_SERVICE: "/Service/list",
    GETBYID_SERVICE: "/Service",
    SERVICE_DELETE: "/Service/",

    //transaction/module
    TRANSACTION_MODULE: "/Transaction/list",
    TRANSACTION_INIT: "/Transaction/get/",
    TRANSACTION_REFUND: "/Transaction/refundable",
    ALIPAY_INQUIRY: "/Transaction/inquiry",
    TRANSACTION_COMPUTATION: "/Transaction/revenue/computation",

    //customerregistrationreport
    CUSTOMER_REGISTRATION_REPORT: "/reports/customerregistration",
    CUSTOMER_REGISTRATION_EXCEL: "/reports/customerregistration/export",
    //transactiondetailreport
    TRANSACTION_DETAIL_REPORT: "/reports/transactiondetail",
    TRANSACTION_DETAIL_INIT: "/reports/transactiondetail/init",
    TRANSACTION_DETAIL_EXPORT: "/reports/transactiondetail/export",
    //transactionsummaryreport
    TRANSACTION_SUMMARY_INIT: "/reports/transactionsummary/init",
    TRANSACTION_SUMMARY_REPORT: "/reports/transactionsummary",
    TRANSACTION_SUMMARY_EXPORT: "/reports/transactionsummary/export",
    //eodreport
    EOD_INIT: "/reports/eod/init",
    EOD_REPORT: "/reports/eod",
    EOD_EXPORT: "/reports/eod/export",
    //refundreport
    REFUND_INIT: "/reports/refund/init",
    REFUND_REPORT: "/reports/refund",
    REFUND_EXPORT: "/reports/refund/export",
    //transactionratehistory
    TRANSACTIONRATEHISTORY_INIT: "/reports/transactionratehistory/init",
    TRANSACTIONRATEHISTORY_REPORT: "/reports/transactionratehistory",
    TRANSACTIONRATEHISTORY_EXPORT: "/reports/transactionratehistory/export",
    //monthlytransaction
    MONTHLYTRANSACTION_INIT: "/reports/monthlytransaction/init",
    MONTHLYTRANSACTION_REPORT: "/reports/monthlytransaction",
    MONTHLYTRANSACTION_EXPORT: "/reports/monthlytransaction/export",
    //fundconversion
    FUNDCONVERSION_INIT: "/",
    FUNDCONVERSION_REPORT: "/reports/fundconversion",
    FUNDCONVERSION_EXPORT: "/reports/fundconversion/export",
});
